import {
	createContext,
	Dispatch,
	ReactNode,
	SetStateAction,
	useEffect,
	useState,
} from 'react';
import { loggerInfo } from 'utils/infoLog';
import { getHRAGroups } from './HealthRiskAssessment.services';
import { RiskAssessmentGroupTypes } from './HealthRiskAssessment.types';

export type HealthRiskAssessmentContextType = {
	riskGroups: RiskAssessmentGroupTypes[];
	setRiskGroups: Dispatch<SetStateAction<RiskAssessmentGroupTypes[]>>;
	isLoading: boolean;
	assignedGroups: RiskAssessmentGroupTypes[];
	selectedGroup: RiskAssessmentGroupTypes | undefined;
	setSelectedGroup: Dispatch<
		SetStateAction<RiskAssessmentGroupTypes | undefined>
	>;
};

type HealthRiskAssessmentProps = {
	children: ReactNode;
};

export const HealthRiskAssessmentContext = createContext(
	{} as HealthRiskAssessmentContextType,
);

export const HealthRiskAssessmentProvider = ({
	children,
}: HealthRiskAssessmentProps): JSX.Element => {
	const [isLoading, setLoading] = useState<boolean>(false);
	const [selectedGroup, setSelectedGroup] =
		useState<RiskAssessmentGroupTypes>();
	const [assignedGroups, setAssignedGroups] = useState<
		RiskAssessmentGroupTypes[]
	>([]);
	const [riskGroups, setRiskGroups] = useState<RiskAssessmentGroupTypes[]>([]);

	const fetchHRAGroups = async () => {
		try {
			setLoading(true);
			const { data } = await getHRAGroups();
			const assignedGroups = data.content.filter(
				(group: RiskAssessmentGroupTypes) => group.isAssigned,
			);
			setRiskGroups(data.content);
			setAssignedGroups(assignedGroups);
		} catch (error) {
			loggerInfo({
				context: 'hra',
				location: 'fetchHealthRiskAssessment',
				data: error,
			});
		} finally {
			setLoading(false);
		}
	};

	useEffect(() => {
		fetchHRAGroups();
	}, []);

	return (
		<HealthRiskAssessmentContext.Provider
			value={{
				riskGroups,
				setRiskGroups,
				isLoading,
				assignedGroups,
				selectedGroup,
				setSelectedGroup,
			}}
		>
			{children}
		</HealthRiskAssessmentContext.Provider>
	);
};
